if (!customElements.get('flock-landing-product')) {
  customElements.define('flock-landing-product', class extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-variant]');
      this.form = this.querySelector('form');
      this.gaugeQuantity = this.querySelector('[data-gauge-quantity]');
      this.extraDisclosure = this.querySelector('[data-extras]');
      if (this.extraDisclosure) this.extraDisclosure.open = !window.matchMedia('(max-width: 749px)').matches;
      this.revealInvalid = (event) => {
        if (event.target.matches('[data-extra-quantity]') && this.extraDisclosure) this.extraDisclosure.open = true;
      };
      this.extraRows = [...this.querySelectorAll('[data-extra-row]')];
      this.money = new Intl.NumberFormat(this.dataset.locale, {
        style: 'currency', currency: this.dataset.currency
      });
      this.update = (event) => {
        const option = this.select?.selectedOptions[0];
        if (!option) return;
        if (this.gaugeQuantity && event?.target === this.select) {
          this.gaugeQuantity.min = option.dataset.min;
          this.gaugeQuantity.step = option.dataset.step;
          if (option.dataset.max) this.gaugeQuantity.max = option.dataset.max;
          else this.gaugeQuantity.removeAttribute('max');
        }
        const gaugeQuantity = this.gaugeQuantity ? Number(this.gaugeQuantity.value) || 0 : 1;
        let total = Number(option.dataset.unitPrice) * gaugeQuantity + Number(this.dataset.adapterPrice);
        let extraCount = 0;
        let itemIndex = this.dataset.adapterAvailable === undefined ? 1 : 2;
        for (const row of this.extraRows) {
          const input = row.querySelector('[data-extra-quantity]');
          const quantity = input.disabled ? 0 : Number(input.value) || 0;
          input.setCustomValidity(quantity > 0 && quantity < Number(input.dataset.min) ? input.dataset.minError : '');
          extraCount += quantity;
          total += Number(row.dataset.unitPrice) * quantity;
          for (const field of row.querySelectorAll('[data-extra-field]')) {
            field.disabled = quantity <= 0;
            field.name = `items[${itemIndex}][${field.dataset.extraField}]`;
            if (field.dataset.extraField === 'quantity') field.value = quantity;
          }
          if (quantity > 0) itemIndex++;
        }
        const count = this.querySelector('[data-extra-count]');
        if (count) {
          count.textContent = `(${extraCount})`;
          count.hidden = extraCount === 0;
        }
        const limit = (4 - Number(option.dataset.connections)) * gaugeQuantity;
        const limitMessage = this.dataset.sensorLimit.replace('__COUNT__', limit);
        const status = this.querySelector('[data-sensor-status]');
        if (status) {
          status.textContent = limitMessage;
          status.classList.toggle('flp-sensor-error', extraCount > limit);
        }
        const firstExtra = this.extraRows.find(row => !row.querySelector('[data-extra-quantity]').disabled);
        if (extraCount > limit && firstExtra) {
          firstExtra.querySelector('[data-extra-quantity]').setCustomValidity(limitMessage);
        }
        this.querySelector('[data-price]').textContent = option.dataset.price;
        this.querySelector('[data-total]').textContent = `${this.money.format(total / 100)} ${this.dataset.currency}`;
        this.querySelector('[data-included-text]').textContent = option.dataset.includes;
        const button = this.querySelector('[data-add]');
        button.disabled = option.dataset.available !== 'true' || this.dataset.adapterAvailable === 'false';
        button.textContent = button.disabled ? this.dataset.soldLabel : this.dataset.addLabel;
      };
      this.form?.addEventListener('invalid', this.revealInvalid, true);
      this.form?.addEventListener('input', this.update);
      this.form?.addEventListener('change', this.update);
      this.update();
      this.querySelector('[data-extras]')?.removeAttribute('hidden');
      this.querySelector('[data-total-wrap]')?.removeAttribute('hidden');
    }
    disconnectedCallback() {
      this.form?.removeEventListener('invalid', this.revealInvalid, true);
      this.form?.removeEventListener('input', this.update);
      this.form?.removeEventListener('change', this.update);
    }
  });
}
